import React, { Fragment, useState } from 'react';
import { Button, Form, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [categoria, setCategoria] = useState("");

    // A cada mudança → aplicar filtro local
    const handleNomeChange = (e) => {
        const value = e.target.value;
        setNome(value);
        props.filtrarLocalmente(value, categoria);
    };

    const handleCategoriaChange = (e) => {
        const value = e.target.value;
        setCategoria(value);
        props.filtrarLocalmente(nome, value);
    };

    const limpar = () => {
        setNome("");
        setCategoria("");
        props.setComponentes(props.componentesOriginais); // restaura lista original
    };

    return (
        <Fragment>
            <Container className="da-espaco">

                <Row xs={1} lg={4}>

                    <Col xs={12} lg={4}>
                        <Form.Label>Componente</Form.Label>
                        <Form.Control
                            type="text"
                            value={nome}
                            onChange={handleNomeChange}
                        />
                    </Col>
                    <Col xs={12} lg={4}>
                        <Form.Group controlId="selectCategoria">
                            <Form.Label>Categoria</Form.Label>
                            <Form.Select required value={categoria} onChange={handleCategoriaChange}>
                                <option value="">TODOS</option>
                                <option value="Computador">Computador</option>
                                <option value="Notebook">Notebook</option>
                                <option value="Teclado">Teclado</option>
                                <option value="Mouse">Mouse</option>
                                <option value="Monitor">Monitor</option>
                                <option value="Processador">Processador</option>
                                <option value="Memória RAM">Memória RAM</option>
                                <option value="HD/SSD">HD/SSD</option>
                                <option value="Placa-mãe">Placa-mãe</option>
                                <option value="Fonte">Fonte</option>
                                <option value="Gabinete">Gabinete</option>
                                <option value="Impressora">Impressora</option>
                                <option value="No-break">No-break</option>
                                <option value="Multifuncional">Multifuncional</option>
                                <option value="Gabinete">Gabinete</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Button
                            type="button"
                            variant="danger"
                            className="alinha-botao"
                            onClick={limpar}
                        >
                            Limpar Busca
                        </Button>
                    </Col>
                    <Col xs={6} lg={2}>
                        <Link to={`/ti/solicitacao/${props.situacao}`}>
                            <Button variant="danger" className="alinha-botao" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default FormBusca;